/**
 * Error keys for Zod schemas
 * auth.error.* 네이밍 컨벤션 적용
 * useTransAuth('error')와 함께 사용
 */

/**
 * Email error keys
 */
export const EmailErrors = {
	required: 'email.required',
	regexError: 'email.regexError',
} as const;

/**
 * Password error keys
 */
export const PasswordErrors = {
	required: 'password.required',
	lengthError: 'password.lengthError',
	regexError: 'password.regexError',
	combinationError: 'password.combinationError',
	whitespaceError: 'password.whitespaceError',
	capsLockError: 'password.capsLockError',
} as const;

/**
 * Auth code error keys
 */
export const AuthCodeErrors = {
	required: 'authCode.required',
	lengthError: 'authCode.lengthError',
	formatError: 'authCode.formatError',
	verifyError: 'authCode.verifyError',
} as const;

/**
 * Confirm password error keys
 */
export const ConfirmPasswordErrors = {
	required: 'confirmPassword.required',
	confirmError: 'confirmPassword.confirmError',
	capsLockError: 'confirmPassword.capsLockError',
} as const;

/**
 * Agreement error keys
 */
export const AgreementErrors = {
	stepinRequired: 'agreements.stepinRequired',
	privacyRequired: 'agreements.privacyRequired',
	age14Required: 'agreements.age14Required',
} as const;

/**
 * Server error keys (서버 에러 코드 매핑용)
 */
export const ServerErrors = {
	duplicatedEmail: 'server.duplicatedEmail',
	emailNotExist: 'server.emailNotExist',
	emailDeliveryFailed: 'server.emailDeliveryFailed',
	verificationTokenNotFound: 'server.verificationTokenNotFound',
	verificationCodeMismatch: 'server.verificationCodeMismatch',
	authenticationNotFound: 'server.authenticationNotFound',
	authenticationUpdateFailed: 'server.authenticationUpdateFailed',
	authenticationNotCompleted: 'server.authenticationNotCompleted',
	guardianAuthenticationRequired: 'server.guardianAuthenticationRequired',
	invalidAuthenticationId: 'server.invalidAuthenticationId',
	invalidAuthenticationType: 'server.invalidAuthenticationType',
	invalidGuardianAuthentication: 'server.invalidGuardianAuthentication',
	sameEmailAsGuardian: 'server.sameEmailAsGuardian',
	passwordFailed: 'server.passwordFailed',
	accesstokenExpired: 'server.accesstokenExpired',
	refreshtokenInvalid: 'server.refreshtokenInvalid',
	tokenExpired: 'server.tokenExpired',
	tokenInvalid: 'server.tokenInvalid',
	unknownError: 'server.unknownError',
	failed: 'server.failed',
	expired: 'server.expired',
} as const;

/**
 * All error keys grouped by category
 */
export const ErrorKeys = {
	email: EmailErrors,
	password: PasswordErrors,
	authCode: AuthCodeErrors,
	confirmPassword: ConfirmPasswordErrors,
	agreements: AgreementErrors,
	server: ServerErrors,
} as const;
